module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp23_3016.461d77a3.png";